function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 5.657)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 32.337,
  y1: 32.337,
  transform: "translate(63.663)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x1: 32.337,
  y2: 32.333,
  transform: "translate(63.663 32.667)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.49,
  transform: "translate(0 32.31)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.49,
  transform: "translate(37.5 32.31)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.49,
  transform: "translate(74.5 32.31)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}));

var SvgArrowDashed = function SvgArrowDashed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105.657,
    height: 76.314,
    viewBox: "0 0 105.657 76.314",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDashed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-dashed.d36b78ac.svg";
export { ForwardRef as ReactComponent };